import { z } from "zod";

import { USERNAME_MATCHER } from "../../../utils/user";
import { subscriptionSchema } from "../subscription/subscriptionSchema";

const goalSchema = z.object({
  id: z.number(),
  sync_uuid: z.string(),
  type: z.string(),
  goal: z.number(),
  completed: z.number(),
  created_at: z.iso.datetime(),
});

export const meStreaksSchema = z.object({
  time_in_prayer: z.number(),
  streak: z.number(),
  longest_streak: z.number(),
  goal: goalSchema.nullable(),
  sessions_count: z.number(),
  goals_completed: z.number(),
});

export const meSchema = z.object({
  adjust_idfa: z.string().optional(),
  appsflyer_id: z.string().nullable().optional(),
  background_track_id: z.number().min(0).nullable(),
  community_notifications_enabled: z.boolean().optional(),
  consent: z.array(z.number()).nullable(),
  country: z.string().nullable(),
  daily_quote_notifications: z.boolean().optional(),
  devices: z
    .array(
      z.object({
        type: z.string().nullable(),
        token: z.string(),
        appsflyer_id: z.string().nullable().optional(),
      }),
    )
    .optional(),
  email: z.email().trim().nullable(),
  favorites: z
    .array(
      z.object({
        id: z.number(),
        prayer_id: z.number(),
      }),
    )
    .optional(),
  goals: z.array(goalSchema).optional(),
  guide: z.string().nullable(),
  has_access_to_admin_dashboard: z.boolean().optional(),
  /** @deprecated */
  has_access_to_parish_admin_dashboard: z.boolean().optional(),
  has_completed_community_onboarding: z.boolean().optional(),
  has_downloaded_app: z.boolean().nullable().optional(),
  has_password: z.boolean().optional(),
  has_seen_plan_message: z.boolean().optional(),
  hashed_id: z.string().optional().nullable(),
  id: z.number(),
  image_url: z.string(),
  is_discoverable_by_community: z.boolean().optional(),
  is_herald: z.boolean().optional().nullable(),
  is_student: z.boolean().optional().nullable(),
  language: z
    .string()
    .max(10)
    .transform((str) => str.replace(/es-419/, "es"))
    .nullable()
    .optional(),
  last_name: z.string().max(255).trim().nullable(),
  motives: z.array(z.number()).nullable().optional(),
  name: z.string().max(255).trim(),
  notifications_enabled: z.boolean(),
  phone: z.string().trim().nullable(),
  prayer_goals: z.array(z.number()).nullable(),
  referral_code: z.string().optional(),
  sessions: z
    .array(
      z.object({
        id: z.number(),
        sync_uuid: z.string(),
        prayer_id: z.number(),
        audio_id: z.number(),
        created_at: z.iso.datetime(),
      }),
    )
    .optional(),
  sharing_to: z.array(z.number()).nullable(),
  subscription: subscriptionSchema.nullable(),
  sync_health: z.boolean(),
  sync_journals: z.boolean(),
  timezone: z.string().nullable(),
  username: z
    .string()
    .regex(new RegExp(USERNAME_MATCHER, "i"))
    .min(3)
    .max(255)
    .nullable()
    .optional(),
  birthdate: z.iso.date().optional().nullable(),
  created_at: z.iso.datetime().optional(),
});

export type Me = z.infer<typeof meSchema>;
export type MeStreaks = z.infer<typeof meStreaksSchema>;
